/** Imperial: BMI = 703 × lbs / in². Metric: BMI = kg / m² */
export function calcBmi({ weight, heightCm, heightFt, heightIn, unit = "imperial" }) {
  if (unit === "metric") {
    const h = parseFloat(heightCm);
    const w = parseFloat(weight);
    if (!h || !w || h <= 0 || w <= 0) return null;
    const meters = h / 100;
    return w / (meters * meters);
  }
  const ft = parseFloat(heightFt) || 0;
  const inches = parseFloat(heightIn) || 0;
  const w = parseFloat(weight);
  const totalInches = ft * 12 + inches;
  if (!totalInches || !w || totalInches <= 0 || w <= 0) return null;
  return (703 * w) / (totalInches * totalInches);
}

export function bmiCategory(bmi) {
  if (bmi == null || Number.isNaN(bmi)) return "Pending";
  if (bmi < 18.5) return "Underweight";
  if (bmi < 25) return "Normal";
  if (bmi < 30) return "Overweight";
  return "Obese";
}


const round1 = (n) => (Number.isFinite(n) ? Math.round(n * 10) / 10 : "");

export function convertVitalsUnit(info, toUnit) {
  const fromUnit = info.unit || "imperial";
  if (fromUnit === toUnit) return { ...info, unit: toUnit };

  if (toUnit === "metric") {
    const metric = toMetricVitals(info);
    return {
      ...info,
      unit: "metric",
      heightCm: metric.heightCm ? round1(metric.heightCm) : "",
      weight: metric.weightKg ? round1(metric.weightKg) : "",
      heightFt: "",
      heightIn: "",
    };
  }

  const cm = parseFloat(info.heightCm);
  const kg = parseFloat(info.weight);
  const totalInches = cm ? cm / 2.54 : 0;
  const ft = totalInches ? Math.floor(totalInches / 12) : "";
  const inches = totalInches ? Math.round(totalInches % 12) : "";
  return {
    ...info,
    unit: "imperial",
    heightFt: ft === "" ? "" : String(ft),
    heightIn: inches === "" ? "" : String(inches),
    weight: kg ? round1(kg / 0.453592) : "",
    heightCm: "",
  };
}

export function toMetricVitals({ weight, heightCm, heightFt, heightIn, unit }) {
  if (unit === "metric") {
    return { heightCm: parseFloat(heightCm), weightKg: parseFloat(weight) };
  }
  const ft = parseFloat(heightFt) || 0;
  const inches = parseFloat(heightIn) || 0;
  const totalInches = ft * 12 + inches;
  const lbs = parseFloat(weight) || 0;
  return {
    heightCm: totalInches * 2.54,
    weightKg: lbs * 0.453592,
  };
}

// ponytail: self-check — fails if formula drifts
if (typeof process !== "undefined" && process.env?.NODE_ENV !== "production") {
  const b = calcBmi({ weight: 165, heightFt: 5, heightIn: 9, unit: "imperial" });
  console.assert(b != null && b > 24 && b < 25 && bmiCategory(b) === "Normal");
  const converted = convertVitalsUnit(
    { unit: "imperial", heightFt: "5", heightIn: "9", weight: "165" },
    "metric"
  );
  const bMetric = calcBmi({ ...converted, unit: "metric" });
  console.assert(bMetric != null && Math.abs(bMetric - b) < 0.2);
}
